import Img from './help.png';
import './Help.css';

const Help = () => {
    return (
        <img className='img-help' src={Img} alt="" />
    );
}

export default Help;
